import {sickLeaveApi} from "@services/api.service";

import {SickLeave} from "@models/sickLeave";

import {getWorkerNumber} from "@utils/tools/worker";
import {getWorkerWorkerFormSettings} from "@services/worker.service";

const getSickLeavesByDate = async (date: string, workerNumber: string | null = null): Promise<SickLeave[]> => {
    try {
        if (!workerNumber) {
            workerNumber = await getWorkerNumber();
        }

        const response: any = await sickLeaveApi.get(`sick-leaves/worker/${workerNumber}/by-date`, {
            params: {date: date},
        });

        return response.data;
    } catch (error) {
        return []
    }
}

const checkHasActiveSickLeave = async (date: string, workerNumber: string | null = null): Promise<boolean> => {
    const workerFormSettings = await getWorkerWorkerFormSettings(workerNumber);

    if (!workerFormSettings.block_reporting_when_active_sick_leave) {
        return false;
    }

    const sickLeaves = await getSickLeavesByDate(date, workerNumber);

    return !!sickLeaves.length;
}

export {
    getSickLeavesByDate,
    checkHasActiveSickLeave,
};
